export default __webpack_public_path__ + "ce18d4a4f6df17c49ad2e78372ac90c2.png";